import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import moment from "moment";
import { API } from "../../../config";

const Info = ({ label, value }) => (
  <div className="info-item">
    <span className="label">{label}</span>
    <span className="value">{value || "-"}</span>
  </div>
);

export default function LabView() {
  const { token } = useParams();
  const [data, setData] = useState({});
  const [documents, setDocuments] = useState([]);

  useEffect(() => {
    console.log("Token from URL:", token);
    getLabData();
  }, [token]);

  const getLabData = async () => {
    try {
      const res = await fetch(`${API}/getlabworkbytoken/${token}`);

      if (!res.ok) {
        throw new Error("Invalid link");
      }
      const result = await res.json();
      console.log("Response=========>>>", result);

      setData(result);
      setDocuments(result.documents || []);
    } catch (error) {
      console.error("Error:", error);
      alert("Invalid link");
    }
  };
  return (
    <div className="lab-container">
      <div className="lab-card">
        <h2 className="title">Lab Work Details</h2>

        <div className="info-grid">
          <Info label="Work Name" value={data.workname} />
          <Info label="Work Type" value={data.worktype} />
          <Info label="Lab Name" value={data.labname} />
          <Info label="Patient" value={data.patient} />
          <Info label="Clinic" value={data.clinic} />
          <Info label="Tooth" value={data.toothnumber} />

          <Info
            label="Given Date"
            value={
              data.givendate ? moment(data.givendate).format("DD MMM YYYY") : ""
            }
          />

          <Info
            label="Receive Date"
            value={
              data.recievedate
                ? moment(data.recievedate).format("DD MMM YYYY")
                : ""
            }
          />

          <Info label="Comment" value={data.comments} />
        </div>

        <div className="documents">
          <h3>Attached Documents</h3>

          <div className="image-row">
            {documents.map((url, i) => (
              <img src={url} alt="doc" className="doc-img" />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
